import { Injectable } from '@angular/core';
import { GenericHttpService } from './generic-http.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class BranchManagementService {
  baseEndPoint;

  constructor(
    public genericHttpService: GenericHttpService,
    private httpclient: HttpClient
  ) {
    this.baseEndPoint = environment.apiURL;
  }

  getAllBranches(queryParams) {
    return this.genericHttpService.Get(
      '/account/branch/?pagination=' + queryParams
    );
  }

  getBranchDetails(queryParams?) {
    if (queryParams)
      return this.genericHttpService.Get(
        '/account/branch/?search=' + queryParams
      );
    return this.genericHttpService.Get('/account/branch/');
  }

  getBranchData(queryParams?: object): Observable<any> {
    let endPoint = this.baseEndPoint + '/account/branch/';
    if (queryParams) {
      endPoint += this.genericHttpService.getQueryString(queryParams);
    }
    return this.httpclient.get(endPoint);
  }

  getBranchDetailById(id) {
    return this.genericHttpService.Get('/account/branch/?branch_id=' + id);
  }

  getBranchType() {
    return this.genericHttpService.Get('/branch-type/');
  }

  createBranch(data: any) {
    let endPoint = this.baseEndPoint + '/account/branch/';
    return this.httpclient.post(endPoint, data);
  }

  toggleBranchStatus(branch_id: number) {
    return this.genericHttpService.Get(
      `/organisation/toggle-branch-status/?branch_id=${branch_id}`
    );
  }

  editBranch(branch_id, data: any) {
    let endPoint =
      this.baseEndPoint + '/account/branch/?branch_id=' + branch_id;
    return this.httpclient.put(endPoint, data);
  }


  getBranchPerUser(accountId) {
    return this.genericHttpService.Get(`/account/branch/?pagination=0&account_id=${accountId}`);
  }
}
